import { useContext, useState } from 'react';
import { Box, FormControl, FormErrorMessage, FormLabel, IconButton, Input, InputGroup, InputRightElement, Text } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { AppContext } from '../../context/appContext';
import  useAuth  from '../../hooks/useAuth';

type WelcomeBannerProps = {
  userName: string | null;
};

const WelcomeBanner = ({ userName }: WelcomeBannerProps) => {
  const [claimNumberValue, setClaimNumberValue] = useState<string>('');
  const [showClaimNumberLengthError, setShowClaimNumberLengthError] = useState<boolean>(false);
  const defaultAppConfig = { REACT_APP_ST_CLAIM_PORTAL_URL: undefined, REACT_APP_ST_ETRACER_URL: undefined }
  const { appConfig: { REACT_APP_ST_CLAIM_PORTAL_URL } = defaultAppConfig } = useContext(AppContext)
  const { profileData } = useAuth();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    setShowClaimNumberLengthError(false);
    setClaimNumberValue(event.target.value);
  };

  const handleEnterKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event?.key && event.key === 'Enter') {
      handleSearchButtonClick();
    }
  };

  const handleSearchButtonClick = (event?: React.MouseEvent<HTMLElement>) => {
    if (event) {
      event.preventDefault();
    }

    if (claimNumberValue.length !== 7) {
      setShowClaimNumberLengthError(true);
    } else {
      setShowClaimNumberLengthError(false);
      claimStatusSearch();
    }
  };

  const  ClaimPortalInternalUrl = "http://claimportal.prodlb.travp.net/tools/";
  const  ChpInternalUrl = "http://claimportalch.prodlb.travp.net/ClaimGateway/jump.ashx?programtype=CH";
  const ClaimPortalPage = "/ClaimCustomerGateway.aspx";
  const ClaimPortalExternalUrl = "https://accessclaim.travelers.com/claimportalcommonch";

  const claimStatusSearch = () => {
    let baseUrl = "";
    let region = "";
    let searchParams = "";
    let noRole=false;
    if(profileData[0]?.Role.IsInternalUser === true){
      region='Internal';
    }else{
      region='External';
    }
     if(profileData[0]?.Role?.RoleCodes?.includes("csmp2")){ //modern user
        //@ts-ignore
        baseUrl = REACT_APP_ST_CLAIM_PORTAL_URL; 
        searchParams = `?clm=${claimNumberValue}&UserType=`+region; 
      }else if(profileData[0]?.Role?.RoleCodes?.includes("cmsp1")){ //legacy user.  
        searchParams = `?sourceportal=RMIS`+(region==='External'?`?`:`&`)+`clm=${claimNumberValue}&UserType=`+region; 
        baseUrl = (region==='External'? ClaimPortalExternalUrl: ClaimPortalInternalUrl) + ClaimPortalPage;
      }else{ //no p1 , no p2   - CHP 
        if(region==='External'){
          noRole=true;
        }else{
          searchParams = region==='External'?"":("&applicationkey=claimSummary&contextid=" + claimNumberValue + "&afo=983&UserType=" + region);
          baseUrl = ChpInternalUrl;
        }
      }
    let url = baseUrl + searchParams;
      if(noRole===true){
        let noAccessWindow= window.open('NoRolePage', 'popup','width=document.body.clientWidth,height=document.body.clientHeight,scrollbars=yes,menubar=no,resizable=yes,directories=no,status=yes,location=no');
        noAccessWindow?.focus();
      }else{
    let newWindow = window.open(url, 'ClaimStatus', 'width=document.body.clientWidth,height=document.body.clientHeight,scrollbars=yes,menubar=no,resizable=yes,directories=no,status=yes,location=no');
    newWindow?.focus();
      }
  };

   return (
    <Box display="flex" mt={1} justifyContent="space-between" width="100%" height="100px" flexWrap="nowrap" px={.1}>
        <Text alignItems="center" as="h1" textStyle="h2">
          Welcome, {userName}
        </Text>
      <FormControl
        isInvalid={showClaimNumberLengthError}
        maxW={250}
      >
        <FormLabel textStyle="label" fontWeight={400}>Search Claim Number</FormLabel>
        <InputGroup mt={-2} size='sm'>
          <Input
            pr='4.5rem'
            type='text'
            maxLength={7}
            onKeyUp={(event) => handleEnterKey(event)}
            onChange={(event) => handleChange(event)}
          />
          <InputRightElement w={12} >
            <IconButton
              onClick={handleSearchButtonClick}
              variant='outlineRight'
              aria-label='submit search'
              size='sm'
              icon={<SearchIcon />}
            />
          </InputRightElement>
        </InputGroup>
        {showClaimNumberLengthError && <FormErrorMessage>Claim Number must be 7 characters.</FormErrorMessage>}
      </FormControl>
    </Box>
  );
};

export default WelcomeBanner;
